import { render, staticRenderFns } from "./ServicesReservationAddedServiceCancel.vue?vue&type=template&id=4b20fbb4&scoped=true&"
import script from "./ServicesReservationAddedServiceCancel.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20fbb4",
  null
  
)

export default component.exports